exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-container {\r\n    z-index: 99999;\r\n}", ""]);

// exports
